<template>
  <div class="home">
    <header>
      <div class="perform">
        <h3>高性能计算平台<br/>整体解决方案提供商</h3>
        <!-- <h3>高性能计算平台·为你而来</h3>
        <p>专业的高性能计算平台整体解决方案提供商</p> -->
        <div class="banner">
          <!-- <transition
            enter-active-class="animate__animated animate__fadeIn"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='bg' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner-bg.png">
              </p>
            </div>
          </transition> -->
          <!-- <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='content pa' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner-content.png">
              </p>
            </div>
          </transition> -->
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-boards"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-boards' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/boards.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__zoomInDown banner-content-line"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-line-solid' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/line-solid.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__zoomInUp banner-content-line"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-line-dashed' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/line-dashed.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__fadeInBottomLeft banner-content-equip1"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip1' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip1.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__fadeInBottomLeft banner-content-equip2"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip2' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip2.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-equip3"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip3' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip3.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__fadeInTopRight banner-content-equip4"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip4' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip4.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__fadeInTopRight banner-content-equip5"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip5' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip5.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__fadeInTopRight banner-content-equip6"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip6' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip6.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-equip7"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-equip7' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/equip7.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-switch"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-switch' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/switch.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__rotateInDownRight banner-content-text"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-text' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner/text.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-tip1"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-tip1' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner-content-mom.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-tip2"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-tip2' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner-content-container.png">
              </p>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInDown banner-content-tip3"
            leave-active-class="animate__animated animate__fadeOut">
            <div class='pa content-tip3' v-show="isShow">
              <p>
                <img src="@/assets/imgs/banner-content-stor.png">
              </p>
            </div>
          </transition>
        </div>
      </div>
    </header>
    <div class="main-wrapper">
      <div class="main">
        <section>
          <img src="@/assets/imgs/home-main1.png">
          <h4>专业</h4>
          <p>深耕高性能计算行业数十年，数百案例实施经验，遍布高校、研究院、企业</p>
        </section>
        <section>
          <img src="@/assets/imgs/home-main2.png">
          <h4>智能</h4>
          <p>混合架构，支持异构处理器，支持各类主流作业调度与并行文件系统，不限硬件，拒绝绑定</p>
        </section>
        <section>
          <img src="@/assets/imgs/home-main3.png">
          <h4>简单</h4>
          <p>交钥匙工程，从基础架构到上层应用，一站式构建高性能计算平台</p>
        </section>
      </div>
    </div>


    <div class="high-wrapper">
      <h2>量身定制的自研产品</h2>
      <div class="high">
        <div class="high-left">
          <img class="bg" src="@/assets/imgs/storageEquipment1Bg.png">
          <img class="equipment" src="@/assets/imgs/storageEquipment1.png">
        </div>
        <div class="high-right">
          <h3>高性能存储</h3>
          <h4>CompubiqStor</h4>
          <p>— 国产自主可控</p>
          <p>— 全定制专用存储系统</p>
          <p>— SAN、NAS融合型存储</p>
          <p>— 高可靠、高可用、高性能</p>
          <p class="more"><a href="#/store">查看详情</a></p>
        </div>
      </div>
      <div class="software">
        <h3>超算运维管理软件</h3>
        <p>—— 掌握信息、运筹帷幄 ——</p>
        <div class="admin">
          <div class="pa professional">
            <img src="@/assets/imgs/software-professional.png">
            <p class="profes pa">
              <span class="title">专业</span>
              <br>
              <span>Professional</span>
            </p>
          </div>
          <div class="pa modern">
            <img src="@/assets/imgs/software-modern.png">
            <p class="mo pa">
              <span class="title">现代</span>
              <br>
              <span>Modern</span>
            </p>
          </div>
          <div class="pa graceful">
            <img src="@/assets/imgs/software-graceful.png">
            <p class="pa">
              <span class="title">优雅</span>
              <br>
              <span>Graceful</span>
            </p>
          </div>
          <div class="pa smooth"> 
            <img src="@/assets/imgs/software-smooth.png">
            <p class="pa">
              <span class="title">丝滑</span>
              <br>
              <span>Smooth</span>
            </p>
          </div>
          <div class="more"><a href="#/software">查看详情</a></div>

          <transition
            enter-active-class="animate__animated animate__bounceInLeft"
            leave-active-class="animate__animated animate__fadeOut">
            <div class="pa pay" v-show="isShowContaner">
              <span class="pa bill">计费统计</span>
              <img class="line" src="@/assets/imgs/home-line1.png">
              <img class="small coin" src="@/assets/imgs/software-pay.png">
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInRight"
            leave-active-class="animate__animated animate__fadeOut">
            <div class="pa warnning" v-show="isShowContaner">
              <img class="line" src="@/assets/imgs/home-line2.png">
              <img class="small alarm" src="@/assets/imgs/software-warnning.png">
              <span class="pa fore">告警预报</span>
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInLeft"
            leave-active-class="animate__animated animate__fadeOut">
            <div class="pa monitor" v-show="isShowContaner">
              <span class="pa">资源监控</span>
              <img class="line" src="@/assets/imgs/home-line3.png">
              <img class="small" src="@/assets/imgs/software-monitor.png">
            </div>
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInRight"
            leave-active-class="animate__animated animate__fadeOut">
            <div class="pa work" v-show="isShowContaner">
              <span class="pa">作业管理</span>
              <img class="line" src="@/assets/imgs/home-line4.png">
              <img class="small" src="@/assets/imgs/software-work.png">
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="container">
        <h3>高性能应用容器</h3>
        <h4>CompubiqContainer</h4>
        <p>打包应用程序，开箱即用<br/>
          去繁就简、解决最后一公里问题<br/>
          原生支持MPI与GPU<br/>
          支持宿主机作业调度与并行文件系统<br/>
          安全增强、无需root<br/>
          平台间可无缝迁移</p>
        <span class="icon1"></span>
        <span class="icon2"></span>
        <span class="icon3"></span>
        <span class="icon4"></span>
        <span class="icon5"></span>
        <span class="icon6"></span>
        <span class="icon7"></span>
        <span class="icon8"></span>
        <span class="icon9"></span>
        <span class="icon10"></span>
        <span class="icon11"></span>
        <span class="icon12"></span>
    </div>

    <div class="partener">
      <div class="partener-cont">
        <h3>战略合作伙伴</h3>
        <div class="logos">

          <transition
            enter-active-class="animate__animated animate__bounceInLeft"
            leave-active-class="animate__animated animate__fadeOut">
            <img class="logo1" v-show="isShowPartenr" src="@/assets/imgs/logo.png">
          </transition>
          <transition
            enter-active-class="animate__animated animate__bounceInRight"
            leave-active-class="animate__animated animate__fadeOut">
            <img class="logo2" v-show="isShowPartenr" src="@/assets/imgs/logo-bl.png">
          </transition>
        </div>
        <div class="desc">
          与北联国芯保持长期战略合作，发展以国产自主可控为基础，构建安全可靠的高性能计算平台
        </div>
      </div>
    </div>

    <div class="about">
      <div class="about-left">
        <img class="bg" src="@/assets/imgs/home-about.png">
      </div>
      <div class="about-right">
        <h3>关于我们</h3>
        <p>南京信易达计算技术有限公司成立于2018 年10月4日，注册在中国(江苏)自由贸易试验区。信易达是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技企业,拥有超算中心建设、部署、运营的自主可控一体化解决方案，产品和服务覆盖政府、军工、高校、金融、医疗及科研等行业。</p>
        <div class="contact">
          <img class="tu" src="@/assets/imgs/home-qr.png"/>
          <h4>025-68155007</h4>
          <p>南京市江北新区腾飞大厦A座4楼</p>
        </div>
      </div>
    </div>
    
    <div class="caser-warpper">
      <div class="caser">
        <h2>客户案例</h2>
        <div class="case">
           <a href="javascript:void(0" class="small">
            <img src="@/assets/imgstore/school-nj.png"/>
          </a>
           <a href="javascript:void(0" class="small">
            <img src="@/assets/imgstore/school-hn.png"/>
          </a>
           <a href="javascript:void(0" class="small small3">
            <img src="@/assets/imgstore/school-sj.png"/>
          </a>
          <a class="small" href="javascript:void(0)">
            <img src="@/assets/imgstore/store-custom3.png">
          </a>
          <a class="small small2" href="javascript:void(0)">
            <img src="@/assets/imgstore/store-custom1.png">
          </a>
          <a href="javascript:void(0)">
            <img src="@/assets/imgs/home-custom3.png"/>
          </a>
        </div>
      </div>
    </div>

    
		<div class="footer">
			<div class="footer-cont">
        <div class="logo">
          <img src="@/assets/imgs/logo.png"/>
        </div>
        <div class="contact">
          <h4>联系我们</h4>
          <p>地址：南京市江北新区腾飞大厦A座4楼</p>
          <p>电话：025-68155007</p>
        </div>
        <div class="qr">
          <img class="tu" src="@/assets/imgs/home-qr.png"/><br />
          <span class="spa">关注我们</span>
        </div>
			</div>
		</div>
    <div class="footer footer2">
      <p>版权所有 © 南京信易达计算技术有限公司 <a style="color: rgba(255,255,255, .4);" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2021021510号-1</a> 苏公网安备 0000000000号</p>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import 'animate.css'
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      state: store.state,
      isShowContaner: false,
      isShowPartenr: false
    };
  },
  mounted () {
    setTimeout(() => {
      window.scrollTo(0, 0)
      this.isShow = true
    }, 100)
  },
  watch: {
    'state.scrollTop' (val, oldVal) {
      console.log('home scrollTop:', val, oldVal)
      this.isShow = val < 600

      this.isShowContaner = val > 1500 && val < 2500

      this.isShowPartenr = val > 2700 && val < 3600
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.home {
  header {
    width: 100%;
    height: 800px;
    // margin: 0 auto;
    background: #006BBF linear-gradient(to right, #348ad1, #0073CE);
  }
  .perform {
    text-align: center;
    margin: 0 auto;
    padding-top: 200px;
    height: 600px;
    width: 1200px;
    position: relative;
    // overflow: hidden;
    h3 {
      font-size: 42px;
      line-height: 84px;
      color: #fff;
      top: 320px;
      left: -80px;
      position: absolute;
    }
    p {
      font-size: 24px;
      line-height: 2;
      color: #333333;
      padding-bottom: 50px;
    }
    img {
      width: 100%;
    }
  }
  // .banner-wrapper {

  // }
  .banner {
    top: 130px;
    left: 250px;
    height: 590px;
    position: absolute;
    width: 1050px;
    transform: scale(.9);
    img {
      width: 100%;
    }
    .bg {
      transform: scale(1.08);
    }
    // .content {
    //   opacity: .3;
    //   top: 35px;
    //   left: 150px;
    //   // width: 70%;
    // }

    .banner-content-boards {
      animation-delay: 300ms;
    }
    .banner-content-line {
      animation-delay: 600ms;
    }
    .banner-content-line {
      animation-delay: 600ms;
    }
    .banner-content-equip1 {
      animation-delay: 700ms;
    }
    .banner-content-equip2 {
      animation-delay: 800ms;
    }
    .banner-content-equip3 {
      animation-delay: 900ms;
    }
    .banner-content-equip4 {
      animation-delay: 1000ms;
    }
    .banner-content-equip5 {
      animation-delay: 1100ms;
    }
    .banner-content-equip6 {
      animation-delay: 1200ms;
    }
    .banner-content-equip7 {
      animation-delay: 1300ms;
    }
    .banner-content-switch {
      animation-delay: 1400ms;
    }
    .banner-content-text {
      animation-delay: 1600ms;
    }
    .banner-content-tip1 {
      animation-delay: 1800ms;
    }
    .banner-content-tip2 {
      animation-delay: 2000ms;
    }
    .banner-content-tip3 {
      animation-delay: 2200ms;
    }

    .content-boards {
      width: 814px;
      height: 576px;
      left: 180px;
      top: 35px;
    }
    .content-line-solid {
      width: 699px;
      height: 418px;
      left: 367px;
      top: 103px;
    }
    .content-line-dashed {
      width: 616px;
      height: 411px;
      left: 423px;
      top: 94px;
    }
    .content-equip1 {
      width: 215px;
      height: 147px;
      left: 223px;
      top: 285px;
    }
    .content-equip2 {
      width: 112px;
      height: 84px;
      left: 767px;
      top: 464px;
    }
    .content-equip3 {
      width: 263px;
      height: 158px;
      left: 399px;
      top: 190px;
    }
    .content-equip4 {
      width: 180px;
      height: 110px;
      left: 516px;
      top: 45px;
    }
    .content-equip5 {
      width: 108px;
      height: 102px;
      left: 716px;
      top: 130px;
    }
    .content-equip6 {
      width: 136px;
      height: 87px;
      left: 822px;
      top: 226px;
    }
    .content-equip7 {
      width: 61px;
      height: 48px;
      left: 391px;
      top: 300px;
    }
    .content-switch {
      width: 613px;
      height: 355px;
      left: 437px;
      top: 164px;
    }
    .content-text {
      width: 595px;
      height: 495px;
      left: 434px;
      top: 64px;
    }
    .content-tip1 {
      width: 192px;
      height: 104px;
      left: 180px;
      top: 185px;
    }
    .content-tip2 {
      width: 179px;
      height: 104px;
      left: 834px;
      top: 49px;
    }
    .content-tip3 {
      width: 179px;
      height: 104px;
      left: 522px;
      top: 400px;
    }
  }
}
.main-wrapper {
  width: 100%;
  background: #fff;
}
.main {
  display: flex;
  justify-content: space-around;
  width: 1200px;
  margin: 100px auto;
  section {
    width: 29%;
    padding: 3%;
  }
  section img {
    width: 30%;
    margin: auto;
    display: block;
    margin-bottom: 5%;
  }
  section h4 {
    text-align: center;
    font-size: 18px;
    color: #465373;
    margin-bottom: 3%;
  }
  section p {
    line-height: 1.6em;
    color: #465373;
  }
}
.high-wrapper {
  width: 100%;
  background-color: #F8F6F6;
  h2 {
    text-align: center;
    padding: 50px 0;
    font-size: 45px;
  }
}
.high {
  display: flex;
  justify-content: space-around;
  align-content: center;
  margin: 0 auto;
  width: 1200px;
}
.high-left {
  padding: 3%;
  width: 45%;
  text-align: center;
  position: relative;
  .bg {
    width: 80%;
    animation: imgRotate 8s infinite linear;
  }
  .equipment {
    position: absolute;
    left: 150px;
    top: 90px;
    width: 50%;
    margin-bottom: 10%;
  }
}
.high-right {
  width: 45%;
  padding: 6% 0 0 10%;
  text-align: left;
  h3 {
    font-size: 35px;
    color: #5b6783;
  }
  h4 {
    font-size: 35px;
    color: #5b6783;
    line-height: 1.5;
    padding-bottom: 20px;
  }
  p {
    font-size: 20px;
    color: #465373;
    line-height: 2;
  }
  .more {
    padding-top: 50px;
    text-align: center;
    font-size: 18px;
    a {
      text-decoration: none;
      color: #465373;
      text-decoration: underline;
      font-size: 19px;
      &:hover {
        color: #2d3b5f;
        font-weight: bold;
      }
    }
  }
}
.software {
  width: 1200px;
  height: 500px;
  margin: auto;
  padding: 130px 0 200px;
  .more {
    position: absolute;
    left: 75.8%;
    top: 410px;
    font-size: 19px;
    text-align: center;
    a {
      text-decoration: none;
      color: #465373;
      text-decoration: underline;
      &:hover {
        color: #2d3b5f;
        font-weight: bold;
      }
    }
  }
}
.software h3 {
  text-align: center;
  font-size: 35px;
  color: #465373;
  margin-bottom: 2%;
}
.software p {
  text-align: center;
  font-size: 20px;
  color: #465373;
}
.admin {
  position: relative;
  img.line {
    height: 40px;
    width: auto;
  }
  img.small {
    position: absolute;
    width: 50px;
  }

}
.admin p {
  display: inline-block;
  color: red;
  margin-left: -11%;
  left: 30px;
  top: 50px;
  color: #fff;
  text-align: left;
  font-size: 13px;
  .title {
    font-size: 15px;
    font-weight: 500;
  }
}
.professional {
  top: 80px;
  left: 520px;
  z-index: 2;
}
.modern {
  top: 80px;
  left: 610px;
  z-index: 1;
  p {
    left: 120px;
    top: 45px;
    text-align: right;
  }
}
.graceful {
  top: 190px;
  left: 460px;
  z-index: 0;
  p {
    left: 35px;
    top: 50px;
  }
}
.smooth {
  top: 168px;
  left: 585px;
  z-index: 4;
  p {
    right: 20px;
    top: 70px;
    text-align: right;
  }
}
.pay {
  top: 120px;
  right: 710px;
  span {
    left: -135px;
    top: -5px;
    font-size: 18px;
  }
  .small {
    top: -17px;
    left: -60px;
  }
}
.warnning {
  top: 120px;
  left: 800px;
  animation-delay: 600ms;
  span {
    right: -135px;
    top: -5px;
    font-size: 18px;
  }
  .small {
    top: -20px;
    right: -60px;
  }
}
.monitor {
  top: 320px;
  right: 710px;
  animation-delay: 500ms;
  span {
    left: -135px;
    top: 25px;
    font-size: 18px;
  }
  .small {
    top: 10px;
    left: -60px;
  }
}
.work {
  top: 290px;
  left: 730px;
  animation-delay: 300ms;
  span {
    right: -135px;
    top: 25px;
    font-size: 18px;
  }
  .small {
    top: 10px;
    right: -60px;
  }
}

.container {
  height: 340px;
  width: 100%;
  background: url("../assets/imgs/home-container-banner.png") no-repeat;
  background-size: 100% 100%;
  padding: 80px 0;
  color: #fff;
  position: relative;
  top: -50px;
  z-index: 100;
  h3, h4, p {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    font-size: 35px;
    padding-bottom: 10px;
  }
  h4 {
    font-size: 35px;
    padding-bottom: 20px;
  }
  p {
    font-size: 18px;
    line-height: 35px;
  }
  span {
    position: absolute;
    animation: shine 3s infinite linear;
    &.icon1,
    &.icon2,
    &.icon3,
    &.icon4,
    &.icon5,
    &.icon6
     {
       right: 50%;
       margin-right: 350px;
       background-repeat: no-repeat;
       background-size: 100%;
       width: 100px;
       height: 100px;
       border-radius: 50%;
    }
    &.icon1 {
      background-image: url("../assets/imgs/home-container-tech1.png");
      top: 50px;
    }
    &.icon2 {
      background-image: url("../assets/imgs/home-container-tech2.png");
      top: 200px;
      margin-right: 420px;
      width: 92px;
      height: 92px;
      animation-delay: 300ms;
    }
    &.icon3 {
      background-image: url("../assets/imgs/home-container-tech3.png");
      top: 180px;
      margin-right: 280px;
      width: 83px;
      height: 83px;
      animation-delay: 100ms;
    }
    &.icon4 {
      background-image: url("../assets/imgs/home-container-tech4.png");
      top: 330px;
      margin-right: 330px;
      width: 76px;
      height: 76px;
      animation-delay: 1000ms;
    }
    &.icon5 {
      background-color: #fff;
      top: 300px;
      margin-right: 540px;
      width: 18px;
      height: 18px;
      animation-delay: 1200ms;
    }
    &.icon6 {
      background-color: #fff;
      top: 350px;
      margin-right: 240px;
      width: 24px;
      height: 24px;
      animation-delay: 1600ms;
    }
    &.icon7,
    &.icon8,
    &.icon9,
    &.icon10,
    &.icon11,
    &.icon12
     {
       left: 50%;
       margin-left: 420px;
       background-repeat: no-repeat;
       background-size: 100%;
       width: 108px;
       height: 108px;
       border-radius: 50%;
    }
    &.icon7 {
      background-image: url("../assets/imgs/home-container-tech5.png");
      top: -15px;
      animation-delay: 1200ms;
    }
    &.icon8 {
      background-image: url("../assets/imgs/home-container-tech6.png");
      top: 110px;
      margin-left: 330px;
      width: 92px;
      height: 92px;
      animation-delay: 800ms;
    }
    &.icon9 {
      background-image: url("../assets/imgs/home-container-tech7.png");
      top: 160px;
      margin-left: 480px;
      width: 96px;
      height: 96px;
      animation-delay: 200ms;
    }
    &.icon10 {
      background-image: url("../assets/imgs/home-container-tech8.png");
      top: 300px;
      margin-left: 350px;
      width: 83px;
      height: 83px;
      animation-delay: 1500ms;
    }
    &.icon11 {
      background-color: #fff;
      top: 60px;
      margin-left: 580px;
      width: 18px;
      height: 18px;
      animation-delay: 300ms;
    }
    &.icon12 {
      background-color: #fff;
      top: 360px;
      margin-left: 520px;
      width: 24px;
      height: 24px;
      animation-delay: 2000ms;
    }
  }
}

.partener {
  position: relative;
  top: -100px;
  padding: 150px 0 100px;
  background: #eee;
  .partener-cont {
    width: 1200px;
    margin: 0 auto;
    h3 {
      font-size: 45px;
      padding: 10px 0 20px;
      text-align: center;
    }
    .logos {
      height: 200px;
      position: relative;
    }
    img {
      position: absolute;
      height: auto;
      top: 50px;
      &.logo1 {
        width: 400px;
        right: 56%;
      }
      &.logo2 {
        width: 430px;
        left: 55%;
      }
    }
    .desc {
      padding: 20px 0;
      text-align: center;
    }
  }
}

.about {
  display: flex;
  justify-content: space-around;
  align-content: center;
  margin: 0 auto;
  width: 1200px;
  padding: 100px 0 60px;

  .about-left {
    width: 30%;
    text-align: center;
    position: relative;
    .bg {
      width: 100%;
    }
  }
  .about-right {
    width: 60%;
    padding-left: 10%;
    padding-top: 50px;
    text-align: left;
    h3 {
      font-size: 35px;
      color: #5b6783;
      padding-bottom: 20px;
    }
    h4 {
      font-size: 20px;
      color: #5b6783;
    }
    p {
      font-size: 14px;
      color: #465373;
      line-height: 2;
    }
    .contact {
      position: relative;
      padding-left: 100px;
      line-height: 40px;
      margin-top: 50px;
      img {
        position: absolute;
        width: 80px;
        left: 0;
        top: 0;
      }
    }
  }
}

.caser-warpper {
  width: 100%;
  height: 520px;
  background: #F8F6F6;
  padding: 50px 0 0;
}
.caser{
  width: 1200px;
  margin: 0 auto;
  h2 {
    text-align: center;
    font-size: 35px;
    color: #465373;
    padding-bottom: 50px;
  }
  .case{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    
    a {
      transition: 500ms all;
      cursor: pointer;
      &.small {
        img {
          width: 330px;
          position: relative;
          top: 5px;
          left: 10px;
        }
        &.small2 {
          img {
            left: -10px;
          }
        }
        &.small3 {
          img {
            left: 25px;
          }
        }
      }
    }
    a:hover {
      transform: scale(1.2);
      z-index: 10;
    }
  }
  .case img{
    width: 280px;
  }
}

.footer {
  background: #2B2B2B;
  // height: 100px;
  font-size: 14px;
  color: rgba(255,255,255, .4);
  .footer-cont {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 130px;
      padding: 20px 0 0;
      img {
        width: 120px;
        background: rgba(255, 255, 255, .9);
        padding: 5px 8px;
        border-radius: 5px;
      }
    }
    .contact {
      flex: 1;
      padding: 20px 0 0 10%;
      line-height: 26px;
      h4 {
        color: rgba(255,255,255, .69);
        font-size: 16px;
        padding-bottom: 10px;
      }
    }
    .qr {
      width: 80px;
      padding: 20px 0;
      text-align: center;
      img {
        width: 80px;
        margin-bottom: 10px;
      }
    }
  }
}
.footer2 {
  background: #2B2B2B;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid rgba(255,255,255,.1);
  text-align: center;
  color: rgba(255,255,255,.4);
  font-size: 12px;
}

@keyframes imgRotate {
  0% {
    opacity: 1;
    transform: rotate(0deg);
  }
  50% {
    opacity: .7;
    transform: rotate(180deg) scale(1.1);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}


@keyframes shine {
  0% {
    opacity: 1;
  }
  50% {
    opacity: .9;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
  }
}


@media (max-width: 1350px) {
  .home .perform h3 {
    left: 0;
  }
  .home .perform .banner {
    left: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue